export function getCommaSeparatedTwoDecimalsNumber(number) {
    if(number !== "") {
        const fixedNumber = Number.parseInt(number).toLocaleString()
        return fixedNumber
    }else {
        return number;
    }
}